import React from 'react';
import i18n from 'i18n-react';

import { FastFacts, ContentHeader, BackButton } from 'C4';

const FastFactsView = () => (
  <div className="contentContainer">
    <ContentHeader
      header={i18n.translate('nav.promote')}
      subtitle={i18n.translate('pageDescriptions.promote')}
      social
      line
    />
    <FastFacts />
  </div>
);

export default FastFactsView;
